export default __webpack_public_path__ + "static/media/desktop_landing_page_bkgr.c989d96c.png";